import { connect } from 'react-redux';
import { applySpec } from 'ramda';

import RegisteredReportsList from 'components/RegisteredReportsList';

import { getUserRole, getUserId } from 'store/selectors/user';
import { requestPatientList } from 'store/actionCreators/patient';
import {
  isPatientsInfoLoading,
  getPatientsDataForReportsList,
  isPatientsInfo,
} from 'store/selectors/reports/patientsInfo';

const mapStateToProps = applySpec({
  role: getUserRole,
  loading: isPatientsInfoLoading,
  isData: isPatientsInfo,
  patientsData: getPatientsDataForReportsList,
  userId: getUserId,
});

const mapDispatchToProps = {
  requestPatientsInfo: requestPatientList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisteredReportsList);
